import { render } from "./pc.vue?vue&type=template&id=8b3664a2"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"

import "./pc.vue?vue&type=style&index=0&id=8b3664a2&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-listing-list/template4/components/table-item/pc.vue'],['render',render],['__file',"pc.vue"]])

export default __exports__